<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="modalTitle" />
    <div class="f-v f-gap-8">
      <div v-if="successes.length" class="t">
        <span>{{ `${toSentence(successes, 'and')} just got a bonus of ${points} ` }}</span>
        <span v-emoji="pointsPhrase" />
        <span>{{ `${successes.length === 1 ? ',' : ' each,'} delivered as a DM from Donut.` }}</span>
      </div>
      <div v-if="tooSoon.length" class="t">
        {{ toSentence(tooSoon, 'and') }} already received this bonus recently. Try again later.
      </div>
      <div v-if="failures.length" class="t">
        <span>Could not send {{ failures.length === 1 ? 'a message or bonus ' : 'messages or bonuses ' }}</span>
        <span>to {{ toSentence(failures, 'or') }}. Please try again!</span>
      </div>
    </div>
    <donut-modal-sections-actions button-text="Close" :show-cancel="false" />
  </div>
</template>

<script setup>
  import { onMounted } from 'vue';
  import { useStore } from 'vuex';

  const { state, commit } = useStore();
  const {
 successes, failures, tooSoon, title, points,
} = state.modal.data;
  const { pointsConfig } = state.bonusEventTemplates;

  const allSucceeded = !failures.length && !tooSoon.length;

  const toSentence = (users, conjunction) => {
    const list = users.map(u => u.name);
    if (list.length === 0) return null;
    if (list.length === 1) return list[0];
    if (list.length === 2) return `${list[0]} ${conjunction} ${list[1]}`;
    if (list.length > 2) return `${list.slice(0, list.length - 1).join(', ')}, ${conjunction} ${list[list.length - 1]}`;
  };
  const pointsPhrase = `${points === 1 ? pointsConfig.points_name : pointsConfig.points_name_plural} :${pointsConfig.emoji}:`;

  const modalTitle = allSucceeded ? `${title} ${successes.length === 1 ? 'bonus' : 'bonuses'} sent!` : 'Uh-oh...';

  // Lifecycle Hooks
  onMounted(() => {
    if (allSucceeded) commit('startConfetti');
  });
</script>
